import * as types from '../mutation-types'

export default {
	namespaced: true,

	state: {
		entities: [],
		customersTypes: [],
		customersCountsByType: [],
		accounts: []
	},

	actions: {
		fetchAll({ commit }, { entityType, name: query, regionId }) {
			const params = { entityType, query, regionId };
			// never send empty query params (keep valid 0 / false values)
			Object.keys(params).forEach(key => {
				if (params[key] === null || params[key] === undefined || params[key] === '') delete params[key];
			});
			return window.axios.get('/entitiesWithTypeId/all', { params })
				.then((response) => {
					commit(types.STORE_ENTITIES, response.data);
					return response.data;
				})
		},

		fetchAllData({ commit }, { typeId, name, perPage }) {
			return window.axios.get('/entitiesWithTypeId', {
				params: {
					typeId,
					name,
					includeContactInfo: true,
					includeAddresses: true,
					nonDeleted: true,
					page: 1,
					perPage
				}
			})
				.then((response) => {
					commit(types.STORE_ENTITIES, response.data);
					return response.data;
				})
		},

		fetchMatchedEntities({ commit }, { name, regionId }) {
			return window.axios.get('/entityExistCheck', { params: { name, regionId } })
				.then(({ data }) => data)
		},

		modify({ commit }, { 
			requestType,
			entityId,
			typeId,
			name,
			reason,
			specialtyId,
			entityAddresses,
			contactInfos,
			entityType,
			loyality,
			relegion,
			personality,
			birthdate,
			weekend,
			personalNote,
			customerInfo,
			hobbies,
			nearbyPointOfSales,
			visitNotes,
			worksInCenters,
			pmWorkHour,
			amWorkHour,
			ownerInfo,
			residentDoctorNames
		}) {
			/*
                requestType:
                0 = Creation
                1 = Modification
                2 = Deletion
            */
			return window.axios.post('/requests/entitymodifications',
				{ 
					entityType,
					requestType,
					entityId,
					typeId,
					name,
					reason,
					specialtyId,
					entityAddresses,
					contactInfos,
					loyality,
					relegion,
					personality,
					birthdate,
					weekend,
					personalNote,
					customerInfo,
					hobbies,
					nearbyPointOfSales,
					visitNotes,
					worksInCenters,
					pmWorkHour,
					amWorkHour,
					ownerInfo,
					residentDoctorNames
				})
		},
	
		directModify({ commit }, { 
			requestType, 
			entityId, 
			typeId, 
			name, 
			reason, 
			specialtyId, 
			entityAddresses, 
			contactInfos, 
			entityType,
			// new
			loyality,
			relegion,
			personality,
			birthdate,
			amWorkHour,
			pmWorkHour,
			// weekend,
			residentDoctorNames,
			personalNote,
			hobbies,
			nearbyPointOfSales,
			visitNotes,
			worksInCenters,
			customerInfo,
			ownerInfo,
		}) {
			/*
                requestType:
                0 = Creation
                1 = Modification
                2 = Deletion

                entityType:
                0 = Center
                1 = Doctor
                2 = Pharmacy
                3 = External
            */
			return window.axios.post('/requests/EntityModifications/AddEntityWithRequest', { 
				requestType, 
				entityId, 
				typeId, 
				name, 
				reason, 
				specialtyId, 
				entityAddresses, 
				contactInfos, 
				entityType,
				// new
				loyality,
				relegion,
				personality,
				birthdate,
				amWorkHour,
				pmWorkHour,
				// weekend,
				residentDoctorNames,
				personalNote,
				hobbies,
				nearbyPointOfSales,
				visitNotes,
				worksInCenters,
				customerInfo,
				ownerInfo
			})
		},

		fetchEntityType ({ commit }) { 
			return window.axios.get('/entities/types', { once: true }).then(({ data }) => {
				commit(types.STORE_CUSTOMERS_TYPES, data)
				return data
			})
		},

		/*
			عدد زبائن المندوب الحالي مقسّماً على أنواع الزبائن
			الشكل المتوقع للرد: [{ typeId: 1, count: 128 }, ...]
			preventHandling: إحصائية ثانوية، لا نُظهر رسالة خطأ عامة إذا لم تتوفر
		*/
		fetchCountsByType ({ commit }) {
			return window.axios.get('/entitiesCountByType', { preventHandling: true }).then(({ data }) => {
				const customersCountsByType = (data || []).map(item => ({
					typeId: item.typeId !== undefined ? item.typeId : item.entityTypeId,
					count: item.count || 0
				}));
				commit(types.STORE_CUSTOMERS_COUNTS_BY_TYPE, customersCountsByType);
				return customersCountsByType;
			})
		},

		resetCountsByType ({ commit }) {
			commit(types.RESET_CUSTOMERS_COUNTS_BY_TYPE);
		},

		fetchQr ({ commit }, { qrCodeData }) {
			return window.axios.post('/entities/qrCode/decode', { qrCodeData }).then(({ data }) => { return data })
		},
		reset({ commit }) {
			commit(types.RESET_ENTITIES);
		},

		fetchAccount({ commit }) {
			return window.axios.get('/account/briefWithEntityTypeId').then(({ data }) => {
				commit(types.STORE_ACCOUNTS, data)
				return data 
			})
		}
	},

	mutations: {
		[types.STORE_ENTITIES](state, entities) {
			state.entities = entities;
		},
        
		[types.RESET_ENTITIES](state) {
			state.entities = [];
		},

		[types.STORE_CUSTOMERS_TYPES](state, customersTypes) {
			state.customersTypes = customersTypes
		},

		[types.STORE_CUSTOMERS_COUNTS_BY_TYPE](state, customersCountsByType) {
			state.customersCountsByType = customersCountsByType
		},

		[types.RESET_CUSTOMERS_COUNTS_BY_TYPE](state) {
			state.customersCountsByType = []
		},

		[types.STORE_ACCOUNTS](state, accounts) {
			state.accounts = accounts
		}
	},

	getters: {
		getEntityById: state => id => state.entities.find(c => c.id === id),
		getEntityByAccountId: state => accountId => state.entities.find(c => c.accountId === accountId || c.id === accountId),
		getCustomerTypeById: state => id => state.customersTypes.find(c => c.id === id)
	}
}